import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CardDesignComponent } from 'src/app/@shared/components/design/slide-up-card/card-design.component';
import { ResizeService } from 'src/app/@shared/services/resize/resize.service';
import { RoutePlanningService } from 'src/app/modules/route-planner/services/route-planning/route-planning.service';
import { SourceDestinationForm } from 'src/app/modules/route-planner/interfaces/route-planning/forms/source-destination-form';
import { RoutePlanning } from 'src/app/modules/route-planner/interfaces/route-planning/@route-planning.interface';
import { DATA_INJECTION_TOKEN } from 'src/app/@shared/services/overlay/overlay.service';
import { ModalService } from 'src/app/@shared/services/modal/modal.service';
import { AddCalendarPopUpComponent } from 'src/app/@shared/components/pop-ups/add-calendar/add-calendar-pop-up.component';
import { FavoritesService } from 'src/app/modules/route-planner/services/favorites/favorites.service';
import { eFavoriteType } from 'src/app/modules/route-planner/enums/favorite/favorite-type.enum';
import { FavoriteRoute } from 'src/app/modules/route-planner/interfaces/favorites/favorite-route.interface';
import { ResultButton } from '../../../shared/detailed-result-buttons/detailed-result-buttons.component';
import { TariffProfile } from 'src/app/modules/route-planner/interfaces/route-planning/gtfs/tariff-profile.interface';
import { FormControl } from '@angular/forms';
import { SelectOption } from 'src/app/@shared/interfaces/select-option.interface';
import { Observable, Subscription, tap } from 'rxjs';
import { ScheduleService } from 'src/app/modules/route-planner/services/schedule/schedule.service';
import { CalendarService } from 'src/app/modules/route-planner/services/calendar/calendar.service';
import { eSectionType } from 'src/app/modules/route-planner/enums/route-planning/section-type.enum';
import { TripStopTimeSourceDestination } from 'src/app/modules/route-planner/interfaces/route-planning/gtfs/trip-stop-time.interface';
import { Section } from 'src/app/modules/route-planner/interfaces/route-planning/section.interface';
import {
  ADD_TO_CALENDAR,
  ROUTE_DETAILS,
  ROUTE_DURATION,
  SHARE,
  SHOW_ON_MAP,
  SHOW_PRICE,
  SPECIAL_MESSAGES,
  DEPARTURE_AT,
  ARRIVAL_AT,
  FROM,
  TO_DIRECTION,
  SINGILE_RIDE,
  DAILY_FREE,
  MONTHLY_FREE,
  ADD_TO_FAVORITES,
  MORE_ACTIONS_MENU,
  PRINT,
  PRINT_ARIA_LABEL,
  REMOVE_FROM_FAVORITES,
  specialMessagesButtonAriaLabel,
  TARIFF_PROFILE_LABEL,
} from 'src/app/modules/route-planner/constants/multi-language.constants';
import {
  Language,
  LanguageService,
} from 'src/app/@shared/services/language/language.service';
import { Direction } from '@angular/cdk/bidi';
import { UtilsService } from 'src/app/@shared/services/utils/utils.service';
import { SourceDestinationResultsMapComponent } from '../source-destination-results-map/source-destination-results-map.component';
import { HourPipe } from 'src/app/modules/route-planner/pipes/hour.pipe';
import { Address } from 'src/app/modules/route-planner/interfaces/location/address.interface';
import { QueryParamsService } from 'src/app/@shared/services/query-params/query-params.service';
import { eTab } from 'src/app/modules/route-planner/enums/route-planning/tabs/tabs.enums';
import { PrintService } from 'src/app/modules/route-planner/services/print/print.service';
const DEFUALT_PROFILE_ID = 1;
const TRIP_CALENDAR_REFRESH_MS = 60_000;

@Component({
    selector: 'app-source-destination-detailed-result',
    templateUrl: './source-destination-detailed-result.component.html',
    styleUrls: ['./source-destination-detailed-result.component.scss'],
    providers: [HourPipe],
    standalone: false
})
export class SourceDestinationDetailedResultComponent
  extends CardDesignComponent
  implements OnInit, OnDestroy
{
  resultButtons: ResultButton[];
  isFavoriteRoute: boolean;
  favoriteChanged: boolean = false;
  route: RoutePlanning;
  selectedProfile: TariffProfile;
  showRoutePrice: boolean;

  priceCalculationLabel: string;
  shareRouteText: string;
  routeDurationText: string;
  /**
   * a11y: aria-label for the tariff <mot-select> combobox (the dropdown shown
   * next to the price toggle, e.g. "רגיל" / "Regular"). The select is
   * intentionally rendered without a visible <mat-label>, so we expose the
   * field's purpose to screen readers via aria-label instead.
   */
  tariffProfileLabel: string = '';
  calculatedDurationText: string;
  routeDetailsText: string;
  showOnMapText: string;
  moreActionsMenuText: string;
  addToFavoritesText: string;
  removeFromFavoritesText: string;
  printText: string;
  printAriaLabelText: string;
  addToCalendarText: string;

  isFirstTime: boolean = true;
  specialMessagesCounter: number

  direction: Direction;

  private tripCalendarRefreshIntervalId: ReturnType<typeof setInterval> | null = null;
  /** In-flight calendar HTTP; cleared each refresh so slow responses do not stack with the next interval. */
  private tripCalendarHttpSubs: Subscription[] = [];

  moreActionsMenuItems: SelectOption<string>[] = [];

  priceProfileFormControl = new FormControl<TariffProfile>(null);
  tariffProfiles: Observable<SelectOption<TariffProfile>[]> =
    this.scheduleService.getTariffProfiles().pipe(
      tap((profiles) => {
        if (!!profiles && profiles.length) {
          const defaultProfile = profiles.find(
            (profile) => profile.value.id == DEFUALT_PROFILE_ID
          );

          this.priceProfileFormControl.setValue(defaultProfile?.value);
        }
      })
    );

  constructor(
    routePlanningService: RoutePlanningService,
    resizeService: ResizeService,

    @Inject(DATA_INJECTION_TOKEN)
    public readonly data: {
      formValues: SourceDestinationForm;
      route: RoutePlanning;
      showRoutePrice: boolean;
      leg: Address | null
    },


    private readonly favoritesService: FavoritesService,
    private readonly modalService: ModalService,
    private readonly scheduleService: ScheduleService,
    private readonly calendarService: CalendarService,
    private readonly languageService: LanguageService,
    private readonly utilsService: UtilsService,
    private readonly queryParamsService: QueryParamsService,
    private readonly cdr: ChangeDetectorRef,
    private readonly printService: PrintService,
  ) {
    super(routePlanningService, resizeService);
    this.priceProfileFormControl.valueChanges.subscribe(
      (profile) => (this.selectedProfile = profile)
    );
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.showRoutePrice = this.data.showRoutePrice;
    if(!this.showRoutePrice) {
      this.priceProfileFormControl.disable();
    }

    this.refreshTripCalendarRealTimes();
    this.tripCalendarRefreshIntervalId = setInterval(
      () => this.refreshTripCalendarRealTimes(),
      TRIP_CALENDAR_REFRESH_MS
    );

    const formValues = this.data.formValues;
    const favoriteRoutes = this.favoritesService.favorites?.routes;

    this.isFavoriteRoute = !!favoriteRoutes?.find((route) => {
      const favoriteRouteFormValues = route.formValues;

      return (
        favoriteRouteFormValues.origin.addressDetails.label ==
          formValues.origin.addressDetails.label &&
        favoriteRouteFormValues.destination.addressDetails.label ==
          formValues.destination.addressDetails.label
      );
    });

    const map = new Map();
    if(!this.data.route.specialMessages.stopMessages) {
      this.data.route.specialMessages.stopMessages = []
    }
    if(!this.data.route.specialMessages.routeMessages) {
      this.data.route.specialMessages.routeMessages = []
    }
    [...this.data.route.specialMessages.routeMessages, ...this.data.route.specialMessages.stopMessages].forEach(item => {
      map.set(item.messageId, item);
  });
    const messages = Array.from(map.values())
    this.specialMessagesCounter = messages.length;

    this.initializeMultiLanguageTexts();
  }

  override ngOnDestroy(): void {
    if (this.tripCalendarRefreshIntervalId != null) {
      clearInterval(this.tripCalendarRefreshIntervalId);
      this.tripCalendarRefreshIntervalId = null;
    }
    this.clearTripCalendarHttpSubs();
    super.ngOnDestroy();
  }

  private clearTripCalendarHttpSubs(): void {
    for (const s of this.tripCalendarHttpSubs) {
      s.unsubscribe();
    }
    this.tripCalendarHttpSubs.length = 0;
  }

  private refreshTripCalendarRealTimes(): void {
    this.clearTripCalendarHttpSubs();

    this.data.route.sections.forEach((section, index) => {
      if (section.type !== eSectionType.TRANSIT) return;

      const routeDesc = section.transport?.description;
      const agencyId = section.agency?.id != null
        ? Number(section.agency.id.toString().split('_')[0])
        : undefined;
      const stopCode = section.departure?.place?.code != null
        ? Number(section.departure.place.code)
        : undefined;
      const departureTime = section.departure?.time;
      const dateTime =
        departureTime instanceof Date
          ? departureTime.toISOString()
          : departureTime != null
            ? new Date(departureTime).toISOString()
            : undefined;
      if (routeDesc == null || agencyId == null || stopCode == null || dateTime == null) return;

      const sub = this.calendarService
        .GetTripCalendarForSourceDestination({
          routeDesc,
          agencyId,
          stopCode,
          dateTime,
        })
        .subscribe({
          next: (response) => {
            if (!response?.data) return;
            this.applyTripCalendarRealTimes(this.data.route.sections[index], response.data);
            this.cdr.markForCheck();
          },
        });
      this.tripCalendarHttpSubs.push(sub);
    });
  }

  private findStopTimeByStopCode(
    data: Record<number, TripStopTimeSourceDestination[]>,
    stopCode: number
  ): TripStopTimeSourceDestination | undefined {
    for (const stopId of Object.keys(data)) {
      const list = data[Number(stopId)];
      const found = list?.find((s) => s.stopcode === stopCode);
      if (found) return found;
    }
    return undefined;
  }

  private applyTripCalendarRealTimes(
    section: Section,
    data: Record<number, TripStopTimeSourceDestination[]>
  ): void {
    const depCode = section.departure?.place?.code != null
      ? Number(section.departure.place.code)
      : undefined;
    if (depCode != null) {
      const depStopTime = this.findStopTimeByStopCode(data, depCode);
      if (
        depStopTime?.realTimeDepartureTime != null &&
        depStopTime?.realTimeDepartureTimeString != null
      ) {
        section.departure.realTime =
          depStopTime.realTimeDepartureTime instanceof Date
            ? depStopTime.realTimeDepartureTime
            : new Date(depStopTime.realTimeDepartureTime);
        section.departure.realTimeString = depStopTime.realTimeDepartureTimeString;
      }
    }
    const arrivalCode =
      section.arrival?.place?.code != null
        ? Number(section.arrival.place.code)
        : undefined;
    if (arrivalCode != null) {
      const arrivalStopTime = this.findStopTimeByStopCode(data, arrivalCode);
      if (
        arrivalStopTime?.realTimeDepartureTime != null &&
        arrivalStopTime?.realTimeDepartureTimeString != null
      ) {
        section.arrival.realTime =
          arrivalStopTime.realTimeDepartureTime instanceof Date
            ? arrivalStopTime.realTimeDepartureTime
            : new Date(arrivalStopTime.realTimeDepartureTime);
        section.arrival.realTimeString = arrivalStopTime.realTimeDepartureTimeString;
      }
    }
    // (section.intermediateStops ?? []).forEach((intermediate) => {
    //   const code =
    //     intermediate.departure?.place?.code != null
    //       ? Number(intermediate.departure.place.code)
    //       : undefined;
    //   if (code == null) return;
    //   const stopTime = this.findStopTimeByStopCode(data, code);
    //   if (
    //     stopTime?.realTimeDepartureTime != null &&
    //     stopTime?.realTimeDepartureTimeString != null
    //   ) {
    //     intermediate.departure.realTime =
    //       stopTime.realTimeDepartureTime instanceof Date
    //         ? stopTime.realTimeDepartureTime
    //         : new Date(stopTime.realTimeDepartureTime);
    //     intermediate.departure.realTimeString = stopTime.realTimeDepartureTimeString;
    //   }
    // });
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe((language) => {
      if (!this.isFirstTime) {
        this.closeCard();
        return;
      }
      this.calcTravelDuration();
      this.direction = language.direction;
      this.priceCalculationLabel = SHOW_PRICE[language.language];
      this.tariffProfileLabel = TARIFF_PROFILE_LABEL[language.language];
      this.shareRouteText = SHARE[language.language];
      this.routeDurationText = ROUTE_DURATION[language.language];
      this.routeDetailsText = ROUTE_DETAILS[language.language];
      this.showOnMapText = SHOW_ON_MAP[language.language];
      this.moreActionsMenuText = MORE_ACTIONS_MENU[language.language];
      this.addToFavoritesText = ADD_TO_FAVORITES[language.language];
      this.removeFromFavoritesText = REMOVE_FROM_FAVORITES[language.language];
      this.printText = PRINT[language.language];
      this.printAriaLabelText = PRINT_ARIA_LABEL[language.language];
      this.addToCalendarText = ADD_TO_CALENDAR[language.language];
      this.buildMoreActionsMenuItems();
      this.initButtons(language);

      this.isFirstTime = false;
    });
  }

  calcTravelDuration() {
    this.calculatedDurationText = this.routePlanningService.calcTravelDuration(
      this.data.route.travelSummary.duration
    );
  }

  toggleFavoriteRoute() {
    const favoriteRoute: FavoriteRoute = {
      ...this.data,
      type: eFavoriteType.ROUTES,
    };

    if (!!this.isFavoriteRoute) {
      this.favoritesService.removeFavorite(favoriteRoute);
    } else {
      this.favoritesService.addNewFavorite(favoriteRoute);
    }

    this.isFavoriteRoute = !this.isFavoriteRoute;
    this.favoriteChanged = true;
    this.buildMoreActionsMenuItems();
  }

  private buildMoreActionsMenuItems(): void {
    const items: SelectOption<string>[] = [];

    if (this.isShowSaveFavoriteRouteButton()) {
      items.push({
        label: this.isFavoriteRoute ? this.removeFromFavoritesText : this.addToFavoritesText,
        value: 'favorite',
        icon: this.isFavoriteRoute ? 'heart-filled' : 'heart',
        ariaLabel: this.isFavoriteRoute ? this.removeFromFavoritesText : this.addToFavoritesText,
        onClick: () => this.toggleFavoriteRoute(),
      });
    }

    items.push(
      {
        label: this.printText,
        value: 'print',
        icon: 'print',
        ariaLabel: this.printAriaLabelText,
        onClick: this.handlePrint.bind(this),
      },
      {
        label: this.addToCalendarText,
        value: 'addCalendar',
        icon: 'calendar-plus',
        ariaHaspopup: 'dialog',
        ariaLabel: this.addToCalendarText,
        onClick: () => {
          this.modalService.openPopUp(AddCalendarPopUpComponent, {
            data: {
              route: this.data.route,
              originName: this.data.formValues?.origin?.addressDetails?.label || '',
              destinationName: this.data.formValues?.destination?.addressDetails?.label || '',
            },
          });
        },
      },
    );

    this.moreActionsMenuItems = items;
  }

  openSpecialMessages() {
    const messages = [
      ...this.data.route.specialMessages.routeMessages,
      ...this.data.route.specialMessages.stopMessages,
    ];
    this.modalService.openSpecialMessagesModal(messages);
  }

  initButtons(language: Language) {

    this.resultButtons = [
      {
        label: SPECIAL_MESSAGES[language.language],
        name: 'specialMessages',
        onClick: this.openSpecialMessages.bind(this),
        icon: 'message-exclamation',
        counter: this.specialMessagesCounter,
        ariaHaspopup: 'dialog',
        ariaLabel: specialMessagesButtonAriaLabel(
          language.language,
          SPECIAL_MESSAGES[language.language],
          this.specialMessagesCounter
        ),
      }
    ].filter(
      (button) =>
        button.name !== 'specialMessages' ||
        (button.name === 'specialMessages' &&
          button.counter &&
          button.counter > 0)
    );
  }

  togglePriceCalculation(): void {
    this.showRoutePrice = !this.showRoutePrice;

    if (!!this.showRoutePrice) {
      this.priceProfileFormControl.enable();
    } else {
      this.priceProfileFormControl.disable();
    }
  }

  shareResults() {
    // First, ensure the form data is in the URL parameters
    if (this.data && this.data.formValues) {
      // Set origin parameters
      if (this.data.formValues.origin) {
        this.routePlanningService.addAddressesToQueryParam([
          {
            queryParam: 'org',
            value: this.data.formValues.origin.addressDetails.label,
          },
          {
            queryParam: 'oll',
            value: `${this.data.formValues.origin.coordinates.lat}_${this.data.formValues.origin.coordinates.lng}`,
          },
        ]);
      }

      // Set destination parameters
      if (this.data.formValues.destination) {
        this.routePlanningService.addAddressesToQueryParam([
          {
            queryParam: 'dest',
            value: this.data.formValues.destination.addressDetails.label,
          },
          {
            queryParam: 'dll',
            value: `${this.data.formValues.destination.coordinates.lat}_${this.data.formValues.destination.coordinates.lng}`,
          },
        ]);
      }

      // Set stop parameters if available
      if (this.data.formValues.stop) {
        this.routePlanningService.addAddressesToQueryParam([
          {
            queryParam: 'stop',
            value: this.data.formValues.stop.addressDetails.label,
          },
          {
            queryParam: 'sll',
            value: `${this.data.formValues.stop.coordinates.lat}_${this.data.formValues.stop.coordinates.lng}`,
          },
        ]);
      }
    }

    // Create a unique route identifier based on stable properties
    const routeIdentifier = this.createRouteIdentifier(this.data.route);
    console.debug('Created route identifier:', routeIdentifier);

    // Add the route identifier to the URL as a query parameter
    this.routePlanningService.addRouteIdentifierToUrl(routeIdentifier);
    console.debug('Added route identifier to URL');

    // Open the share modal with the updated URL
    this.modalService.openShareLinkModal();
  }
  handlePrint() {
    const headerDetails = document.querySelector<HTMLElement>('.print-header-details');
    const routeDetails = document.querySelector<HTMLElement>('.print-route-details');

    if (!headerDetails || !routeDetails) {
      console.warn('Printable content not found!');
      return;
    }

    this.printService.print([headerDetails, routeDetails], {
      title: this.routeDetailsText,
    });
  }

  /**
   * Creates a unique identifier for a route based on stable properties
   * This identifier should remain consistent for the same logical route
   */
  private createRouteIdentifier(route: RoutePlanning): string {
    // Extract stable properties from the route
    const originLat = route.sections[0].departure.place.location.lat.toFixed(6);
    const originLng = route.sections[0].departure.place.location.lng.toFixed(6);
    const destLat =
      route.sections[
        route.sections.length - 1
      ].arrival.place.location.lat.toFixed(6);
    const destLng =
      route.sections[
        route.sections.length - 1
      ].arrival.place.location.lng.toFixed(6);
    const departureTime = new Date(route.sections[0].departure.time).getTime();
    const arrivalTime = new Date(
      route.sections[route.sections.length - 1].arrival.time
    ).getTime();
    const duration = route.travelSummary.duration;

    // Create a string with a consistent format that matches our parsing logic
    const routeString = `${originLat},${originLng}|${destLat},${destLng}|${departureTime}|${arrivalTime}|${duration}`;
    console.debug('Route string before encoding:', routeString);

    // Return a base64 encoded version of the string to make it URL-friendly
    return btoa(routeString);
  }

  override closeCard(shouldReload: boolean = false): void {
    // Clear the routeId parameter when closing the detailed view
    this.routePlanningService.clearRouteIdentifier();

    super.closeCard({ shouldReload, favoriteChanged: this.favoriteChanged });
  }

  override handleOverlayEscape(): void {
    this.closeCard(false);
  }

  isShowSaveFavoriteRouteButton(): boolean {
    const params = this.queryParamsService._currentParams
    return params["tab"] === eTab.SOURCE_DESTINATION 
  }
}
